import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDatepicker } from '@angular/material/datepicker';
import { ApiService } from 'src/app/shared/services/api.service';
import { ToastrMsgService } from 'src/app/shared/services/shared-services/toastr.service';

@Component({
  selector: 'app-add-bidding',
  templateUrl: './add-bidding.component.html',
  styleUrl: './add-bidding.component.css'
})
export class AddBiddingComponent implements OnInit {
  biddingForm!: FormGroup;
  selectedDomain = 'Residential'; // default
  domainOptions:any = [];
  //   [
  //   'Residential', 'Commercial', 'Educational', 'Water',
  //   'Power', 'Gas', 'Telecom', 'Road', 'Consultancy'
  // ];
  optionsMap: { [key: string]: any[] } = {
    domainOptionsDrp: this.domainOptions
  };

  domainFields: { [key: string]: any[] } = {
    Residential: [
      { key: 'housingUnitCost', label: 'Housing Unit Cost', type: 'currency', value: '' },
      { key: 'amenitiesProposal', label: 'Amenities Proposal', type: 'text', value: '' }
    ],
    Commercial: [
      { key: 'retailSpaceBid', label: 'Retail Space Bid', type: 'number', value: '' },
      { key: 'parkingAllocation', label: 'Parking Allocation', type: 'number', value: '' }
    ],
    Educational: [
      { key: 'classroomConstruction', label: 'Classroom Construction', type: 'currency', value: '' },
      { key: 'labSetupProposal', label: 'Lab Setup Proposal', type: 'text', value: '' }
    ],
    Water: [
      { key: 'treatmentPlantCost', label: 'Treatment Plant Cost', type: 'currency', value: '' },
      { key: 'pipelineLengthBid', label: 'Pipeline Length Bid', type: 'distance', value: '' }
    ],
    Power: [
      { key: 'transformerSupplyCost', label: 'Transformer Supply Cost', type: 'currency', value: '' },
      { key: 'substationSetupBid', label: 'Substation Setup Bid', type: 'currency', value: '' }
    ],
    Gas: [
      { key: 'pipelineInstallation', label: 'Pipeline Installation', type: 'currency', value: '' },
      { key: 'safetyEquipmentCost', label: 'Safety Equipment Cost', type: 'currency' }
    ],
    Telecom: [
      { key: 'towerConstructionBid', label: 'Tower Construction Bid', type: 'currency', value: '' },
      { key: 'fiberOpticCabling', label: 'Fiber Optic Cabling', type: 'distance', value: '' }
    ],
    Road: [
      { key: 'asphaltSupplyRate', label: 'Asphalt Supply Rate', type: 'currency', value: '' },
      { key: 'roadLengthBid', label: 'Road Length Bid', type: 'distance', value: '' }
    ],
    Consultancy: [
      { key: 'advisoryFeeProposal', label: 'Advisory Fee Proposal', type: 'currency', value: '' },
      { key: 'scopeOfServices', label: 'Scope of Services', type: 'text', value: '' }
    ]
  };
  commonFields = [
    { key: 'bidId', label: 'Bid ID', type: 'text', required: true, value: '' },
    { key: 'projectName', label: 'Project Name', type: 'text', required: true, value: '' },
    { key: 'bidType', label: 'Bid Type', type: 'text', required: true, value: '' },
    { key: 'bidSubmissionDate', label: 'Bid Submission Date', type: 'date', required: true, value: '' },
    { key: 'bidderName', label: 'Bidder Name', type: 'text', required: true, value: '' },
    { key: 'bidAmount', label: 'Bid Amount', type: 'currency', required: true, value: '' },
    { key: 'evaluationCriteria', label: 'Evaluation Criteria', type: 'text', required: true, value: '' },
    { key: 'technicalProposalRef', label: 'Technical Proposal Ref', type: 'text', value: '' },
    { key: 'financialProposalRef', label: 'Financial Proposal Ref', type: 'text', value: '' },
    { key: 'bidStatus', label: 'Bid Status', type: 'text', required: true, value: '' },
    { key: 'domain', label: 'Domain', type: 'select', optionKey: 'domainOptionsDrp', required: true, value: 'Residential', onChange: (value: string) => this.onDomainChange(value) }
  ];

  pickerMap: { [key: string]: MatDatepicker<any> } = {};
  constructor(private fb: FormBuilder, private readonly apiService: ApiService, private readonly toastrMsgService: ToastrMsgService) { }

 ngOnInit(): void {
  const userData = JSON.parse(localStorage.getItem('user') || '{}');
    
    
  this.domainOptions = userData.user?.domain.split(",") || [];
  this.optionsMap['domainOptionsDrp']= this.domainOptions;
  console.log(this.domainOptions, this.optionsMap['domainOptionsDrp']);
  this.biddingForm = this.fb.group({});
  this.commonFields.forEach(field => {
    const validators = field.required ? [Validators.required] : [];
    this.biddingForm.addControl(field.key, this.fb.control(field.value || '', validators));
  });
  this.onDomainChange(this.selectedDomain);
}






 patchSampleData() {
  const sampleData: any = {
    bidId: 'BID-2024-001',
    projectName: 'SigmaTConflux Infrastructure Project',
    bidType: 'Open Tender',
    bidSubmissionDate: '2024-02-15',
    bidderName: 'InfraBuild Ltd',
    bidAmount: '₹ 97,500,000',
    evaluationCriteria: 'Cost, Experience, Timeline',
    technicalProposalRef: 'TECHPROP-2024-Infra',
    financialProposalRef: 'FINPROP-2024-Infra',
    bidStatus: 'Under Review',
    domain: 'Residential', 
    housingUnitCost: '₹12,00,000/unit',
    amenitiesProposal: 'Clubhouse, Park'
  };

  this.onDomainChange(sampleData.domain); 
  this.biddingForm.patchValue(sampleData);
}

  onSubmit() {
    if (this.biddingForm.valid) {
      console.log(this.biddingForm.value);
    }
  }
  onReset(): void {
    this.biddingForm.reset();
  }
onDomainChange(domain: string) {
    this.selectedDomain = domain;
    Object.keys(this.biddingForm.controls).forEach(key => {
      if (key !== 'domain' && this.domainFields[domain]?.find(field => field.key === key) === undefined &&
        Object.values(this.domainFields).flat().some(field => field.key === key)) {
        this.biddingForm.removeControl(key);
      }
    });
    this.domainFields[domain].forEach(field => {
      this.biddingForm.addControl(field.key, this.fb.control(field.value));
    });

  }

}